import type { IUserScoreData, IUserStatsData } from '@/entities';
import type { IApiUserImagesResponse, IApiUserScoreResponse, IUserStatsResponse } from '@/services';
import type { IUserAvatarData } from '@/entities';

export const mapUserScore = (data: Readonly<IApiUserScoreResponse>): IUserScoreData => {
  return {
    id: data.id,
    name: data.name,
    points: data.points,
    rank: data.rank
  };
};

export const mapUserAvatar = (data: Readonly<IApiUserImagesResponse>): IUserAvatarData => {
  return {
    id: data.id,
    imageUrl: data.imageUrl
  };
};

export const mapUserStats = (data: Readonly<IUserStatsResponse>): IUserStatsData => {
  return {
    points: data.points,
    rank: data.rank,
    pointsToNextLevel: data.pointsToNextLevel,
    learnerId: data.learnerId,
    learnerName: data.learnerName,
    lastCompleted: data.lastCompleted,
    topInWorld: data.topInWorld,
    rankInRegion: data.rankInRegion
      ? {
          place: data.rankInRegion.place,
          totalNumberOfLearners: data.rankInRegion.totalNumberOfLearners,
          name: data.rankInRegion.name
        }
      : undefined,
    rankInCountry: data.rankInCountry
      ? {
          place: data.rankInCountry.place,
          totalNumberOfLearners: data.rankInCountry.totalNumberOfLearners,
          name: data.rankInCountry.name
        }
      : undefined,
    rankInAccount: data.rankInAccount
      ? {
          place: data.rankInAccount.place,
          totalNumberOfLearners: data.rankInAccount.totalNumberOfLearners,
          name: data.rankInAccount.name
        }
      : undefined,
    rankInAccountType: data.rankInAccountType
      ? {
          place: data.rankInAccountType.place,
          totalNumberOfLearners: data.rankInAccountType.totalNumberOfLearners,
          name: data.rankInAccountType.name
        }
      : undefined
  };
};
